import { BasicActionOptionsProps } from 'constants/service'
import { NurserySettingsFormBuilder } from 'services/nurseries/models'

import { generateBasicActions } from 'utils/service'

import {
  UPDATE_FORM_BUILDER_SETTINGS,
  UPDATE_FORM_BUILDER_SETTINGS_FAILED,
  UPDATE_FORM_BUILDER_SETTINGS_SUCCESS,
} from './constants'

export const update = (
  options: BasicActionOptionsProps<NurserySettingsFormBuilder>,
) => ({ formBuilderSettingsApiClient }) => generateBasicActions.update({
  constants: {
    failed: UPDATE_FORM_BUILDER_SETTINGS_FAILED,
    init: UPDATE_FORM_BUILDER_SETTINGS,
    success: UPDATE_FORM_BUILDER_SETTINGS_SUCCESS,
  },
  options,
  service: formBuilderSettingsApiClient,
  serviceMethod: 'update',
})
